import RibbonButton from './RibbonButton';
import RibbonPlugin from '../../plugin/RibbonPlugin';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import controlStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { createLink } from 'roosterjs-editor-api';
import { QueryScope } from 'roosterjs-editor-types';

let styles = require('./insertLink.scss');

const insertLink: RibbonButton = {
    key: 'insertLink',
    title: () => strings.createLink,
    imageSrc: require('../svg/createlink.svg'),
    // The actual keyboard shortcut handling logic is in RibbonPlugin.
    // These strings, in most cases, are documenting behaviour that already exists in
    // Rooster or is implemented by a plugin.
    shortcutWin: 'Ctrl+K',
    shortcutMac: '⌘+K',
    onExecute: showInsertLinkDialog,
};

export default insertLink;
export interface InsertLinkProperties {
    DisplayText: string;
    LinkUrl: string;
    HasChanged: boolean;
}

export async function displayInsertLinkDialog(
    setLink: InsertLinkProperties
): Promise<DialogResponse> {
    let linkInput: HTMLInputElement;
    let displayTextInput: HTMLInputElement;
    return await confirm(strings.linkTitle, null /*subText*/, false /*resolveImmediately*/, {
        okText: controlStrings.okButton,
        cancelText: controlStrings.cancelButton,
        bodyElement: (
            <div className={styles.linkContent}>
                <div className={styles.displayTextInputBox}>
                    <label htmlFor="displayTextInput">{strings.displayTextLabel}</label>
                    <input
                        id="displayTextInput"
                        role="textbox"
                        type="text"
                        ref={ref => (displayTextInput = ref)}
                        onChange={() => {
                            setLink.DisplayText = displayTextInput.value;
                            setLink.HasChanged = true;
                        }}
                        defaultValue={setLink.DisplayText}
                        className={styles.linkInput}
                    />
                </div>
                <div className={styles.linkInputBox}>
                    <label htmlFor="linkInput">{strings.urlLabel}</label>
                    <input
                        id="linkInput"
                        role="textbox"
                        type="text"
                        ref={ref => (linkInput = ref)}
                        onChange={() => {
                            if (displayTextInput.value == setLink.LinkUrl) {
                                setLink.DisplayText = linkInput.value;
                                displayTextInput.value = linkInput.value;
                            }
                            setLink.LinkUrl = linkInput.value;
                            setLink.HasChanged = true;
                        }}
                        defaultValue={setLink.LinkUrl}
                        className={styles.linkInput}
                    />
                </div>
            </div>
        ),
        delayCallbackAfterAnimation: true,
        containerClassName: styles.linkDialog,
        focusSelector: '#linkInput',
    });
}

export async function showInsertLinkDialog(plugin: RibbonPlugin) {
    let editor = plugin.getEditor();
    let range = editor.getSelectionRange();
    const insertLink: InsertLinkProperties = {
        LinkUrl: '',
        DisplayText: '',
        HasChanged: false,
    };
    try {
        const linkNode = editor.queryElements(
            'a[href]',
            QueryScope.OnSelection
        )[0] as HTMLAnchorElement;
        insertLink.LinkUrl = linkNode.href;
        insertLink.DisplayText = linkNode.textContent;
    } catch (e) {
        insertLink.DisplayText = range.toString();
    }

    plugin.workaroundFocusIssueForFirefox();

    if (DialogResponse.ok === (await displayInsertLinkDialog(insertLink))) {
        editor.select(range);
        if (insertLink.HasChanged) {
            createLink(
                editor,
                insertLink.LinkUrl,
                insertLink.LinkUrl,
                insertLink.DisplayText.length > 0 ? insertLink.DisplayText : null
            );
        }
    } else {
        editor.select(range);
    }
}
